import VSpacer from './VSpacer.vue';

export { VSpacer };
export default VSpacer;
